import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Menu, CreditCard } from 'lucide-react';
import { NavigationItem } from './NavigationItem';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useState } from 'react';
import logo from '../../assets/logo.png';
import CreditsDisplay from './CreditsDisplay';

export const MobileNavigation = ({ navigation }) => {
    const { user } = useAuth();
    const [isOpen, setIsOpen] = useState(false);

    // Split navigation items similar to Sidebar
    const mainNavigation = navigation.slice(0, 3);
    const secondaryNavigation = navigation.slice(3, -1);
    const helpItem = navigation[navigation.length - 1];

    const handleNavigationClick = () => {
        setIsOpen(false);
    };

    return (
        <div className="flex items-center md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
                <SheetTrigger asChild>
                    <Button variant="ghost" size="icon">
                        <Menu className="h-5 w-5" />
                    </Button>
                </SheetTrigger>
                <SheetContent side="left" className="w-64 p-0">
                    <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
                    <SheetDescription className="sr-only">
                        Application navigation menu with links to different sections and features
                    </SheetDescription>
                    {/* Header with logo */}
                    <div className="h-16 flex items-center px-4 border-b border-gray-200 dark:border-gray-700">
                        <Link to="/" onClick={handleNavigationClick}>
                            <img
                                src={logo}
                                alt="Klasite"
                                className="h-8 w-auto"
                            />
                        </Link>
                    </div>

                    {/* Navigation sections */}
                    <div className="flex flex-col h-[calc(100vh-4rem)]">
                        <div className="flex-1 overflow-y-auto">
                            <nav className="px-4 pt-5 space-y-1">
                                {/* Main navigation items */}
                                {mainNavigation.map((item) => (
                                    <NavigationItem
                                        key={item.name}
                                        item={item}
                                        mobile={true}
                                        onClick={handleNavigationClick}
                                    />
                                ))}

                                {/* First separator */}
                                <div className="py-4">
                                    <Separator className="dark:bg-gray-700" />
                                </div>

                                {/* Secondary navigation items */}
                                {secondaryNavigation.map((item) => (
                                    <NavigationItem
                                        key={item.name}
                                        item={item}
                                        mobile={true}
                                        onClick={handleNavigationClick}
                                    />
                                ))}

                                {/* Second separator */}
                                <div className="py-4">
                                    <Separator className="dark:bg-gray-700" />
                                </div>

                                {/* Help & Support item */}
                                <NavigationItem
                                    item={helpItem}
                                    mobile={true}
                                    onClick={handleNavigationClick}
                                />
                            </nav>
                        </div>

                        {/* Credits display and button at bottom */}
                        <div className="px-4 pb-6 border-t border-gray-200 dark:border-gray-700">
                            <div className="mt-6 mb-3 flex justify-between">
                                <div className="text-gray-600 dark:text-gray-400">
                                    Credits:
                                </div>
                                <CreditsDisplay userId={user?.id} />
                            </div>
                            <Link
                                to="/buy-credits"
                                className="flex items-center justify-center gap-2 w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
                                onClick={handleNavigationClick}
                            >
                                <CreditCard className="h-4 w-4" />
                                Get More Credits
                            </Link>
                        </div>
                    </div>
                </SheetContent>
            </Sheet>

            {/* Mobile header title */}
            <Link to="/" className="ml-4">
                <img
                    src={logo}
                    alt="Klasite"
                    className="h-8 w-auto"
                />
            </Link>
        </div>
    );
};